import { wellnub } from '../wellnub.api';

export const requestCards = () => wellnub.get('/v1/client/payment/card');

export const requestAddCard = data =>
  wellnub.post('/v1/client/payment/card', data);

export const requestSetDefaultCard = id =>
  wellnub.patch(`/v1/client/payment/card/defaultCard/${id}`);

export const requestDeleteCard = id =>
  wellnub.delete(`/v1/client/payment/card/${id}`);

// `returnPath` va aquí y no en quien llama porque se puede comprar pases desde
// varias pantallas, y así ninguna tiene que acordarse de mandarlo. El backend
// valida que sea una ruta interna y le antepone su propio origen; nunca se manda
// una URL completa.
//
// Solo importa cuando Conekta pide 3DS: el usuario sale de la app y vuelve
// exactamente a donde estaba. useConektaRedirectReturn se encarga del resto,
// incluido refrescar el número de pases en pantalla.
export const requestBuyPasses = payload =>
  wellnub.post('/v1/client/payment/buyCoins', {
    ...payload,
    returnPath: `${window.location.pathname}${window.location.search}`,
  });

// Confirma una compra después del reto 3DS. El backend re-consulta la orden con
// Conekta (estado autoritativo, no el que reporta el navegador) y otorga los pases.
export const requestConfirmBuyPasses = async payload => {
  const { data } = await wellnub.post(
    '/v1/client/payment/buyCoins/confirm',
    payload,
  );
  return data;
};

export const requestValidateDiscountCode = async code => {
  const { data } = await wellnub.get(
    `/v1/client/payment/promotion/search?code=${code}`,
  );
  return data;
};

export const requestGetSubscriptions = async () => {
  const { data } = await wellnub.get('/v1/client/payment/subscription');
  return data;
};

export const requestBuySubscription = async payload => {
  const { data } = await wellnub.post(
    '/v1/client/payment/subscription',
    payload,
  );
  return data;
};

export const requestCancelSubscription = async () => {
  const { data } = await wellnub.delete('/v1/client/payment/subscription');
  return data;
};
